package link.erpango.quip.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.SnackbarDuration
import androidx.compose.material.SnackbarHost
import androidx.compose.material.SnackbarHostState
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Done
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.rememberScaffoldState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import compose.icons.AllIcons
import compose.icons.FontAwesomeIcons
import compose.icons.fontawesomeicons.Brands
import compose.icons.fontawesomeicons.Regular
import compose.icons.fontawesomeicons.Solid
import compose.icons.fontawesomeicons.brands.Dev
import compose.icons.fontawesomeicons.solid.Asterisk
import compose.icons.fontawesomeicons.solid.Calendar
import compose.icons.fontawesomeicons.solid.CashRegister
import compose.icons.fontawesomeicons.solid.FlagCheckered
import compose.icons.fontawesomeicons.solid.Lock
import compose.icons.fontawesomeicons.solid.MoneyBill
import compose.icons.fontawesomeicons.solid.Paste
import compose.icons.fontawesomeicons.solid.Road
import compose.icons.fontawesomeicons.solid.Warehouse
import kotlinx.coroutines.launch
import link.erpango.quip.domain.entities.DMaintenance
import link.erpango.quip.domain.entities.DSparePart
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.ui.components.QuipCard
import link.erpango.quip.ui.components.QuipPrimaryButton
import link.erpango.quip.ui.components.QuipSectionHeader
import link.erpango.quip.ui.components.QuipTransparentHeader
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.utils.DatetimeUtils
import org.jetbrains.compose.resources.stringResource
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material.icons.filled.Check
import androidx.compose.ui.input.nestedscroll.nestedScroll
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.add_maintenance
import quip.composeapp.generated.resources.edit_maintenance
import quip.composeapp.generated.resources.add_spare_part
import quip.composeapp.generated.resources.additional_info_label
import quip.composeapp.generated.resources.category_label
import quip.composeapp.generated.resources.complete_required_fields
import quip.composeapp.generated.resources.cost_label
import quip.composeapp.generated.resources.date
import quip.composeapp.generated.resources.date_label
import quip.composeapp.generated.resources.durability_days_label
import quip.composeapp.generated.resources.error_adding_maintenance
import quip.composeapp.generated.resources.kilometers_label
import quip.composeapp.generated.resources.maintenance_added_successfully
import quip.composeapp.generated.resources.maintenance_cost
import quip.composeapp.generated.resources.maintenance_details
import quip.composeapp.generated.resources.mechanic
import quip.composeapp.generated.resources.odometer
import quip.composeapp.generated.resources.ok
import quip.composeapp.generated.resources.quantity_label
import quip.composeapp.generated.resources.required
import quip.composeapp.generated.resources.spare_parts
import quip.composeapp.generated.resources.workshop
import quip.composeapp.generated.resources.delete_maintenance_title
import quip.composeapp.generated.resources.delete_maintenance_message
import quip.composeapp.generated.resources.maintenance_deleted_successfully
import quip.composeapp.generated.resources.error_deleting_maintenance
import quip.composeapp.generated.resources.delete
import quip.composeapp.generated.resources.cancel
import quip.composeapp.generated.resources.sign_maintenance_title
import quip.composeapp.generated.resources.sign_maintenance_message
import quip.composeapp.generated.resources.sign_maintenance_confirm
import quip.composeapp.generated.resources.create_maintenance_title
import quip.composeapp.generated.resources.create_maintenance_message
import quip.composeapp.generated.resources.create_maintenance_confirm
import link.erpango.quip.ui.components.QuipDialogGeneric
import link.erpango.quip.ui.components.QuipDropdownTextField
import link.erpango.quip.domain.catalog.DefaultSparePartCatalog
import link.erpango.quip.domain.noteimport.DatePrecision
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.domain.noteimport.toDSparePart
import link.erpango.quip.features.noteimport.NoteImportSelection
import link.erpango.quip.features.noteimport.NoteImportViewModel
import link.erpango.quip.ui.noteimport.NoteImportDialog
import link.erpango.quip.ui.noteimport.NoteImportEntryCard
import link.erpango.quip.ui.noteimport.NoteImportReviewBanner
import link.erpango.quip.ui.noteimport.SuggestionMarker
import link.erpango.quip.ui.noteimport.rememberFormSuggestions
import quip.composeapp.generated.resources.note_import_date_approx

enum class BackTrigger {
    DELETE,
    CREATE,
    EDIT,
    NO_OP
}

/**
 * Formulario para añadir un mantenimiento con repuestos asociados.
 */
@Composable
fun AddMaintenanceScreen(
    vehicle: DVehicle,
    maintenanceToEdit: DMaintenance? = null,
    temporarySpareParts: List<DSparePart>,
    onAddMaintenance: (DMaintenance, (Boolean) -> Unit) -> Unit,
    onDeleteMaintenance: ((DMaintenance, (Boolean, String?) -> Unit) -> Unit)? = null,
    onNavigateToAddSparePart: () -> Unit,
    onRemoveSparePart: (DSparePart) -> Unit,
    onBackClick: () -> Unit,
    innerPadding: PaddingValues,
    // Autocomplete data
    distinctMechanics: List<String> = emptyList(),
    distinctWorkshops: List<String> = emptyList(),
    /** "Rellenar desde nota": solo al crear; null lo oculta. */
    noteImportViewModel: NoteImportViewModel? = null,
    /** Repuestos completos que la nota propone añadir al mantenimiento. */
    onAddSuggestedSpareParts: (List<DSparePart>) -> Unit = {},
) {
    // Localized strings
    val dateLabel = stringResource(Res.string.date_label)
    val kilometersLabel = stringResource(Res.string.kilometers_label)
    val costLabel = stringResource(Res.string.cost_label)
    val maintenanceAddedSuccessfully = stringResource(Res.string.maintenance_added_successfully)
    val errorAddingMaintenance = stringResource(Res.string.error_adding_maintenance)
    val completeRequiredFields = stringResource(Res.string.complete_required_fields)
    val required = stringResource(Res.string.required)
    val categoryLabel = stringResource(Res.string.category_label)
    val quantityLabel = stringResource(Res.string.quantity_label)
    
    val maintenanceDetailsTitle = stringResource(Res.string.maintenance_details)
    val addMaintenanceTitle = stringResource(Res.string.add_maintenance)
    val editMaintenanceTitle = stringResource(Res.string.edit_maintenance)
    
    // Delete maintenance strings
    val deleteMaintenanceTitle = stringResource(Res.string.delete_maintenance_title)
    val deleteMaintenanceMessage = stringResource(Res.string.delete_maintenance_message)
    val maintenanceDeletedSuccessfully = stringResource(Res.string.maintenance_deleted_successfully)
    val errorDeletingMaintenance = stringResource(Res.string.error_deleting_maintenance)
    val deleteText = stringResource(Res.string.delete)
    val cancelText = stringResource(Res.string.cancel)
    
    // Sign maintenance strings
    val signMaintenanceTitle = stringResource(Res.string.sign_maintenance_title)
    val signMaintenanceMessage = stringResource(Res.string.sign_maintenance_message)
    val signMaintenanceConfirm = stringResource(Res.string.sign_maintenance_confirm)
    
    // Create maintenance strings
    val createMaintenanceTitle = stringResource(Res.string.create_maintenance_title)
    val createMaintenanceMessage = stringResource(Res.string.create_maintenance_message)
    val createMaintenanceConfirm = stringResource(Res.string.create_maintenance_confirm)

    // State variables
    var dateInMillis by rememberSaveable { mutableStateOf(maintenanceToEdit?.date ?: DatetimeUtils.currentTimeMillis()) }
    var cost by rememberSaveable { mutableStateOf(maintenanceToEdit?.cost?.toString() ?: "") }
    var kilometers by rememberSaveable { mutableStateOf(maintenanceToEdit?.kilometers?.toString() ?: "") }
    var mechanic by rememberSaveable { mutableStateOf(maintenanceToEdit?.mechanic ?: "") }
    var workshop by rememberSaveable { mutableStateOf(maintenanceToEdit?.workshop ?: "") }
    var description by rememberSaveable { mutableStateOf(maintenanceToEdit?.description ?: "") }

    // "Rellenar desde nota": the default date (today) counts as empty until the user picks one.
    var dateTouched by rememberSaveable { mutableStateOf(maintenanceToEdit != null) }
    val suggestions = rememberFormSuggestions<MaintenanceFormField>()
    var showNoteImport by remember { mutableStateOf(false) }
    var showReviewBanner by remember { mutableStateOf(false) }
    var approximateDate by remember { mutableStateOf<String?>(null) }

    fun applyNoteSelection(selection: NoteImportSelection.Maintenance) {
        val draft = selection.draft
        val note = selection.note
        suggestions.clearAll()
        suggestions.apply(MaintenanceFormField.DATE, draft.date, note, !dateTouched, { it == dateInMillis }) {
            dateInMillis = it
            dateTouched = true
        }
        approximateDate = draft.rawDate?.takeIf { draft.date != null && draft.datePrecision == DatePrecision.MONTH }
        suggestions.apply(
            MaintenanceFormField.COST, draft.cost, note, cost.isBlank(), { it == cost.toDoubleOrNull() },
            display = ::formatAmount,
        ) { cost = formatAmount(it) }
        suggestions.apply(MaintenanceFormField.KILOMETERS, draft.kilometers, note, kilometers.isBlank(), { it == kilometers.toIntOrNull() }) {
            kilometers = it.toString()
        }
        suggestions.apply(MaintenanceFormField.DESCRIPTION, draft.description, note, description.isBlank(), { it == description }) {
            description = it
        }
        suggestions.apply(MaintenanceFormField.MECHANIC, draft.mechanic, note, mechanic.isBlank(), { it.equals(mechanic, ignoreCase = true) }) {
            mechanic = it
        }
        suggestions.apply(MaintenanceFormField.WORKSHOP, draft.workshop, note, workshop.isBlank(), { it.equals(workshop, ignoreCase = true) }) {
            workshop = it
        }
        onAddSuggestedSpareParts(selection.parts.mapNotNull { it.toDSparePart(DefaultSparePartCatalog) })
        showReviewBanner = true
    }

    // Delete dialog state
    var showDeleteDialog by remember { mutableStateOf(false) }
    
    // Sign dialog state
    var showSignDialog by remember { mutableStateOf(false) }
    var pendingMaintenanceToSign by remember { mutableStateOf<DMaintenance?>(null) }
    
    // Create dialog state
    var showCreateDialog by remember { mutableStateOf(false) }
    var pendingMaintenanceToCreate by remember { mutableStateOf<DMaintenance?>(null) }

    // Snackbar handling
    val snackbarHostState = remember { SnackbarHostState() }
    val coroutineScope = rememberCoroutineScope()

    Scaffold(
        scaffoldState = rememberScaffoldState(snackbarHostState = snackbarHostState),
        floatingActionButton = {
            FloatingActionButton(
                onClick = {
                    println("Debug: dateInMillis: $dateInMillis, kilometers: '$kilometers', cost: '$cost', description: '$description'")
                    val missingFields = mutableListOf<String>()
                    if (dateInMillis == null) missingFields.add(dateLabel)
                    if (kilometers.isBlank()) missingFields.add(kilometersLabel)
                    if (cost.isBlank()) missingFields.add(costLabel)
                    
                    if (missingFields.isEmpty()) {
                        val maintenance = DMaintenance(
                            id = maintenanceToEdit?.id,
                            vehicleVin = vehicle.vin,
                            date = dateInMillis!!,
                            cost = cost.toDoubleOrNull() ?: 0.0,
                            kilometers = kilometers.toIntOrNull() ?: 0,
                            description = description.ifBlank { "N/A" },
                            mechanic = mechanic.ifBlank { "N/A" },
                            workshop = workshop.ifBlank { "N/A" },
                            spareParts = temporarySpareParts
                        )
                        
                        // If editing (which means signing), show confirmation dialog first
                        if (maintenanceToEdit != null) {
                            pendingMaintenanceToSign = maintenance
                            showSignDialog = true
                        } else {
                            // Adding new maintenance - show confirmation dialog first
                            pendingMaintenanceToCreate = maintenance
                            showCreateDialog = true
                        }
                    } else {
                        coroutineScope.launch {
                             snackbarHostState.showSnackbar(
                                 message = completeRequiredFields.replace("%s", missingFields.joinToString(", ")),
                                 duration = SnackbarDuration.Short
                             )
                        }
                    }
                },
                backgroundColor = QuipColors.colorPrimary,
                contentColor = Color.White
            ) {
                // Show Lock icon for signing when editing, Done icon for adding
                if (maintenanceToEdit != null) {
                    Icon(
                        imageVector = FontAwesomeIcons.Solid.Lock,
                        contentDescription = "Sign Maintenance",
                        modifier = Modifier.size(24.dp)
                    )
                } else {
                    Icon(Icons.Default.Done, contentDescription = "Add Maintenance")
                }
            }
        },
        snackbarHost = { SnackbarHost(it) },
        backgroundColor = QuipColors.colorBackground
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .padding(innerPadding)
                .imePadding()
        ) {
            // Header
            QuipTransparentHeader {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        IconButton(onClick = onBackClick) {
                            Icon(
                                Icons.Default.ArrowBack,
                                contentDescription = "Back",
                                tint = QuipColors.colorText
                            )
                        }
                        Spacer(modifier = Modifier.width(8.dp))
                        Text(
                            text = if (maintenanceToEdit != null) editMaintenanceTitle else addMaintenanceTitle,
                            style = MaterialTheme.typography.h5,
                            fontWeight = androidx.compose.ui.text.font.FontWeight.Bold,
                            color = QuipColors.colorText
                        )
                    }
                    
                    // Delete button only visible when editing and not signed
                    if (maintenanceToEdit != null && !maintenanceToEdit.isSigned && onDeleteMaintenance != null) {
                        IconButton(onClick = { showDeleteDialog = true }) {
                            Icon(
                                Icons.Default.Delete,
                                contentDescription = "Delete Maintenance",
                                tint = QuipColors.colorError
                            )
                        }
                    }
                }
            }

            LazyColumn(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 16.dp),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
            // Header spacing
            //item { Spacer(modifier = Modifier.height(56.dp)) }

            if (maintenanceToEdit == null && noteImportViewModel != null) {
                item {
                    if (showReviewBanner) {
                        NoteImportReviewBanner(
                            missingFields = listOfNotNull(
                                kilometersLabel.takeIf { kilometers.isBlank() },
                                costLabel.takeIf { cost.isBlank() },
                            ),
                            onDismiss = { showReviewBanner = false }
                        )
                    } else {
                        NoteImportEntryCard(onClick = {
                            noteImportViewModel.open(NoteImportTarget.MAINTENANCE, contextVehicleVin = vehicle.vin)
                            showNoteImport = true
                        })
                    }
                }
            }

            // Fecha
            item {
                DatePickerField(
                    label = stringResource(Res.string.date),
                    currentDate = dateInMillis,
                    onDateSelected = {
                        dateInMillis = it
                        dateTouched = true
                        approximateDate = null
                        suggestions.clear(MaintenanceFormField.DATE)
                    },
                    helperText = { Text(required, color = QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[MaintenanceFormField.DATE])
                approximateDate?.let { raw ->
                    Text(
                        text = stringResource(Res.string.note_import_date_approx, raw),
                        style = MaterialTheme.typography.caption,
                        color = QuipColors.colorWarning,
                        modifier = Modifier.padding(start = 8.dp, top = 4.dp)
                    )
                }
            }

            // Coste
            item {
                QuipTextField(
                    value = cost,
                    onValueChange = { cost = it; suggestions.clear(MaintenanceFormField.COST) },
                    label = stringResource(Res.string.maintenance_cost),
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Number,
                        imeAction = ImeAction.Next
                    ),
                    icon = FontAwesomeIcons.Solid.CashRegister,
                    helperText = { Text(required, color = QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[MaintenanceFormField.COST])
            }

            // Kilómetros
            item {
                QuipTextField(
                    value = kilometers,
                    onValueChange = { kilometers = it; suggestions.clear(MaintenanceFormField.KILOMETERS) },
                    label = stringResource(Res.string.odometer),
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Number,
                        imeAction = ImeAction.Next
                    ),
                    icon = FontAwesomeIcons.Solid.Road,
                    helperText = { Text(required, color = QuipColors.colorText.copy(alpha = 0.6f), modifier = Modifier.padding(start = 16.dp)) }
                )
                SuggestionMarker(suggestions[MaintenanceFormField.KILOMETERS])
            }

            // Mecánico
            item {
                QuipDropdownTextField(
                    options = distinctMechanics,
                    selectedOption = mechanic.takeIf { it.isNotBlank() && distinctMechanics.contains(it) },
                    label = stringResource(Res.string.mechanic),
                    isFiltrable = true,
                    onOptionSelected = { _, option -> mechanic = option; suggestions.clear(MaintenanceFormField.MECHANIC) },
                    onTextChanged = { mechanic = it; suggestions.clear(MaintenanceFormField.MECHANIC) },
                    onClearOption = { mechanic = ""; suggestions.clear(MaintenanceFormField.MECHANIC) }
                )
                SuggestionMarker(suggestions[MaintenanceFormField.MECHANIC])
            }

            // Taller
            item {
                QuipDropdownTextField(
                    options = distinctWorkshops,
                    selectedOption = workshop.takeIf { it.isNotBlank() && distinctWorkshops.contains(it) },
                    label = stringResource(Res.string.workshop),
                    isFiltrable = true,
                    onOptionSelected = { _, option -> workshop = option; suggestions.clear(MaintenanceFormField.WORKSHOP) },
                    onTextChanged = { workshop = it; suggestions.clear(MaintenanceFormField.WORKSHOP) },
                    onClearOption = { workshop = ""; suggestions.clear(MaintenanceFormField.WORKSHOP) }
                )
                SuggestionMarker(suggestions[MaintenanceFormField.WORKSHOP])
            }
            /*
            Ejemplo de uso
            var options = listOf("1000", "2000", "3000", "4000", "5000")
                var selectedOption = options[0]
            // Duración
            item {
                QuipDropdownTextField(
                    label = stringResource(Res.string.durability_days_label),
                    options = listOf("1000", "2000", "3000", "4000", "5000"),
                    selectedOption = selectedOption,
                    onOptionSelected = { index, option ->
                        selectedOption = options[index]
                                       },
                    isFiltrable = true,
                    onTextChanged = {
                      selectedOption = it
                    }
                )
            }*/

            // Detalles
            item {
                QuipTextField(
                    value = description,
                    onValueChange = { description = it; suggestions.clear(MaintenanceFormField.DESCRIPTION) },
                    label = stringResource(Res.string.maintenance_details),
                    keyboardOptions = KeyboardOptions(
                        imeAction = ImeAction.Done
                    ),
                    icon = FontAwesomeIcons.Solid.Paste,
                    minLines = 3
                )
                SuggestionMarker(suggestions[MaintenanceFormField.DESCRIPTION])
            }

            // Sección de repuestos
            item {
                QuipSectionHeader(title = stringResource(Res.string.spare_parts), icon = Icons.Default.Add)
                QuipPrimaryButton(
                    text = stringResource(Res.string.add_spare_part),
                    onClick = onNavigateToAddSparePart,
                    icon = Icons.Default.Add
                )
            }

            // Lista de repuestos añadidos
            items(temporarySpareParts) { sparePart ->
                QuipCard {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Column(modifier = Modifier.weight(1f)) {
                            Text(
                                text = "${sparePart.brand} ${sparePart.model}",
                                style = MaterialTheme.typography.body1,
                                color = Color.Black
                            )
                             Text(
                                 text = categoryLabel + sparePart.categoryId,
                                 style = MaterialTheme.typography.body2,
                                 color = QuipColors.colorText
                             )
                            if (sparePart.quantity != null && sparePart.unit != null) {
                             Text(
                                 text = quantityLabel + "${sparePart.quantity} ${sparePart.unit}",
                                 style = MaterialTheme.typography.body2,
                                 color = QuipColors.colorText
                             )
                            }
                            if (sparePart.additionalInfo.isNotBlank()) {
                                Text(
                                    text = sparePart.additionalInfo,
                                    style = MaterialTheme.typography.caption,
                                    color = QuipColors.colorText
                                )
                            }
                        }
                        IconButton(onClick = { onRemoveSparePart(sparePart) }) {
                            Icon(Icons.Default.Delete, contentDescription = "Delete", tint = QuipColors.colorError)
                        }
                    }
                }
                Spacer(modifier = Modifier.height(8.dp))
            }

            // Espaciador final
            item { Spacer(modifier = Modifier.height(80.dp)) }
        }
        
        // Delete confirmation dialog
        if (showDeleteDialog) {
            QuipDialogGeneric(
                title = deleteMaintenanceTitle,
                message = deleteMaintenanceMessage,
                confirmButtonText = deleteText,
                dismissButtonText = cancelText,
                onConfirm = {
                    showDeleteDialog = false
                    maintenanceToEdit?.let { maintenance ->
                        onDeleteMaintenance?.invoke(maintenance) { success, error ->
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar(
                                    message = if (success) {
                                        maintenanceDeletedSuccessfully
                                    } else {
                                        error ?: errorDeletingMaintenance
                                    },
                                    duration = SnackbarDuration.Short
                                )
                                if (success) {
                                    // Navigate back after deleting
                                    kotlinx.coroutines.delay(300)
                                    onBackClick()
                                }
                            }
                        }
                    }
                },
                onDismiss = { showDeleteDialog = false },
                isConfirmColored = true,
                accentColor = QuipColors.colorError
            )
        }
        
        // Sign confirmation dialog
        if (showSignDialog) {
            QuipDialogGeneric(
                title = signMaintenanceTitle,
                message = signMaintenanceMessage,
                confirmButtonText = signMaintenanceConfirm,
                dismissButtonText = cancelText,
                onConfirm = {
                    showSignDialog = false
                    pendingMaintenanceToSign?.let { maintenance ->
                        onAddMaintenance(maintenance) { success ->
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar(
                                    message = if (success) maintenanceAddedSuccessfully else errorAddingMaintenance,
                                    duration = SnackbarDuration.Short
                                )
                            }
                        }
                    }
                    pendingMaintenanceToSign = null
                },
                onDismiss = { 
                    showSignDialog = false 
                    pendingMaintenanceToSign = null
                },
                isConfirmColored = true
            )
        }
        
        // Create confirmation dialog
        if (showCreateDialog) {
            QuipDialogGeneric(
                title = createMaintenanceTitle,
                message = createMaintenanceMessage,
                confirmButtonText = createMaintenanceConfirm,
                dismissButtonText = cancelText,
                onConfirm = {
                    showCreateDialog = false
                    pendingMaintenanceToCreate?.let { maintenance ->
                        onAddMaintenance(maintenance) { success ->
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar(
                                    message = if (success) maintenanceAddedSuccessfully else errorAddingMaintenance,
                                    duration = SnackbarDuration.Short
                                )
                            }
                        }
                    }
                    pendingMaintenanceToCreate = null
                },
                onDismiss = { 
                    showCreateDialog = false 
                    pendingMaintenanceToCreate = null
                },
                isConfirmColored = true
            )
        }

        if (showNoteImport && noteImportViewModel != null) {
            NoteImportDialog(
                viewModel = noteImportViewModel,
                sparePartCatalog = DefaultSparePartCatalog,
                onDismiss = {
                    showNoteImport = false
                    noteImportViewModel.reset()
                },
                onApply = { selection ->
                    if (selection is NoteImportSelection.Maintenance) applyNoteSelection(selection)
                    showNoteImport = false
                    noteImportViewModel.reset()
                }
            )
        }
    }
    }
}

/** Fields of the maintenance form that can be filled from a note. */
private enum class MaintenanceFormField { DATE, COST, KILOMETERS, DESCRIPTION, MECHANIC, WORKSHOP }

/** 145.0 -> "145", 89.9 -> "89.9": the way a user types an amount. */
private fun formatAmount(value: Double): String =
    if (value % 1.0 == 0.0) value.toLong().toString() else value.toString()
